import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FaStar, FaArrowLeft, FaArrowRight, FaQuoteRight } from "react-icons/fa";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css/navigation";

export default function Testimonials() {
    const reviews = [
        {
            name: "Ahmed Khan",
            role: "Traveler",
            image: "https://randomuser.me/api/portraits/men/32.jpg",
            review:
                "Amazing experience! The booking was smooth and the hotel exceeded expectations. Highly recommended!",
        },
        {
            name: "Sara Ali",
            role: "Tourist",
            image: "https://randomuser.me/api/portraits/women/44.jpg",
            review:
                "Best travel platform I’ve used. Great deals and excellent customer support!",
        },
        {
            name: "John Smith",
            role: "Business Traveler",
            image: "https://randomuser.me/api/portraits/men/12.jpg",
            review:
                "Very professional service. I always find the best hotels here for my business trips.",
        },
        {
            name: "Ali Raza",
            role: "Explorer",
            image: "https://randomuser.me/api/portraits/men/55.jpg",
            review:
                "Super easy booking process and great hotel recommendations. Loved it!",
        },
    ];

    return (
        <section className="relative overflow-hidden bg-[#001925] py-16 sm:py-20 lg:py-24">

            {/* Background Effects */}
            <div className="absolute top-0 left-0 w-96 h-96 bg-[#174B5F]/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>

            <div className="absolute bottom-0 right-0 w-[450px] h-[450px] bg-[#D4A83F]/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>

            {/* Decorative Quote */}
            <div className="absolute top-10 right-[8%] text-white/[0.025]">
                <FaQuoteRight className="text-[180px] sm:text-[240px]" />
            </div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Heading */}
                <div className="max-w-3xl mx-auto text-center mb-12 sm:mb-14">

                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 backdrop-blur-md mb-5">
                        <span className="w-2 h-2 rounded-full bg-[#D4A83F]"></span>

                        <span className="text-xs sm:text-sm font-bold tracking-wide text-white/90">
                            GUEST REVIEWS
                        </span>
                    </div>

                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold !text-white leading-tight">
                        Loved By Travelers,
                        <span className="block text-[#D4A83F]">
                            Trusted By Guests
                        </span>
                    </h2>

                    <p className="text-slate-300 text-sm sm:text-base leading-7 mt-5 max-w-2xl mx-auto">
                        Thousands of travelers trust us to find the best hotels
                        and experiences across Dubai.
                    </p>

                    {/* Rating Summary */}
                    <div className="flex justify-center items-center gap-3 mt-6">

                        <div className="flex items-center gap-1 text-[#D4A83F]">
                            {[...Array(5)].map((_, i) => (
                                <FaStar key={i} className="text-sm" />
                            ))}
                        </div>

                        <span className="w-px h-5 bg-white/20"></span>

                        <span className="text-sm text-white/70">
                            4.9 / 5 from our guests
                        </span>

                    </div>
                </div>

                {/* Navigation */}
                <div className="flex justify-center gap-3 mb-8">

                    <button
                        className="custom-prev group w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-white/10 border border-white/10 backdrop-blur-md text-white flex items-center justify-center hover:bg-[#D4A83F] hover:text-[#002B45] hover:border-[#D4A83F] transition-all duration-300"
                    >
                        <FaArrowLeft className="text-sm group-hover:-translate-x-0.5 transition-transform" />
                    </button>

                    <button
                        className="custom-next group w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-white/10 border border-white/10 backdrop-blur-md text-white flex items-center justify-center hover:bg-[#D4A83F] hover:text-[#002B45] hover:border-[#D4A83F] transition-all duration-300"
                    >
                        <FaArrowRight className="text-sm group-hover:translate-x-0.5 transition-transform" />
                    </button>

                </div>

                {/* Testimonials */}
                <Swiper
                    modules={[Autoplay, Pagination, Navigation]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    navigation={{
                        nextEl: ".custom-next",
                        prevEl: ".custom-prev",
                    }}
                    autoplay={{
                        delay: 3500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                    className="!pb-12"
                >
                    {reviews.map((item, index) => (
                        <SwiperSlide key={index} className="h-auto">

                            <div className="group relative h-full min-h-[330px] bg-white/[0.07] backdrop-blur-xl border border-white/10 rounded-3xl p-6 sm:p-7 hover:bg-white/[0.10] hover:border-[#D4A83F]/40 hover:-translate-y-1.5 transition-all duration-500">

                                {/* Top Row */}
                                <div className="flex items-start justify-between">

                                    {/* Quote Icon */}
                                    <div className="w-12 h-12 rounded-2xl bg-[#D4A83F]/10 border border-[#D4A83F]/20 flex items-center justify-center">
                                        <FaQuoteRight className="text-[#D4A83F] text-lg" />
                                    </div>

                                    {/* Rating */}
                                    <div className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/10">
                                        <FaStar className="text-[#D4A83F] text-xs" />

                                        <span className="text-xs font-bold text-white">
                                            5.0
                                        </span>
                                    </div>

                                </div>

                                {/* Stars */}
                                <div className="flex items-center gap-1 mt-6">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar
                                            key={i}
                                            className="text-[#D4A83F] text-xs"
                                        />
                                    ))}
                                </div>

                                {/* Review */}
                                <p className="text-slate-300 text-sm sm:text-[15px] leading-7 mt-5">
                                    “{item.review}”
                                </p>

                                {/* Bottom */}
                                <div className="absolute bottom-0 left-0 right-0 px-6 sm:px-7 pb-6 sm:pb-7">

                                    <div className="h-px bg-white/10 mb-5"></div>

                                    <div className="flex items-center justify-between gap-3">

                                        <div className="flex items-center gap-3">

                                            <div className="relative">
                                                <img
                                                    src={item.image}
                                                    alt={item.name}
                                                    className="w-12 h-12 rounded-full object-cover border-2 border-[#D4A83F]/50"
                                                />

                                                <span className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-[#D4A83F] text-[#002B45] flex items-center justify-center text-[9px] font-bold border-2 border-[#001925]">
                                                    ✓
                                                </span>
                                            </div>

                                            <div>
                                                <h4 className="font-bold text-white text-sm">
                                                    {item.name}
                                                </h4>

                                                <p className="text-xs text-slate-400 mt-0.5">
                                                    {item.role}
                                                </p>
                                            </div>

                                        </div>

                                        <span className="text-[9px] uppercase tracking-widest font-bold text-slate-500">
                                            Verified
                                        </span>

                                    </div>

                                </div>

                                {/* Hover Accent */}
                                <div className="absolute bottom-0 left-8 right-8 h-[2px] bg-gradient-to-r from-transparent via-[#D4A83F] to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>

                            </div>

                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </section>
    );
}